module.exports = ".content-wrapper{padding-left:0px;padding-right:0px}.container-fluid{padding-left:0px;padding-right:0px}\n"